<template>
  <div class="footer">
    <div class="content">
      <div class="hui box">
        <div class="title title1">
          <div>
            <img class="bgImage" src="@/images/home/1-27.png"/>
          </div>
        </div>
        <div class="main" :style="$store.state.i18n?'':'transform:translateY(-0.56vw);'">
          <div class="fotBox fotBox1" :style="$store.state.i18n?'':'letter-spacing:0;'">
            <a target="_blank" :style="$store.state.i18n?'':'font-size:1.458vw;letter-spacing:0vw;'" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">{{$store.state.i18n?componentsLang.pc.chinese.footer.reference.icp:componentsLang.pc.english.footer.reference.icp}}</a> 
            <img style="margin: 0 0.417vw 0 0.625vw;height: 2.0832vw;width: 1.875vw;" src="@/images/home/1-43.png" />
            <!-- <img style="margin: 0 0.617vw 0 0.625vw; height: 0.666624vw;width: 0.6vw;" src="@/images/home/1-43.png" /> -->
            <a target="_blank" :style="$store.state.i18n?'':'font-size:1.458vw;letter-spacing:0vw;'" href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action">{{$store.state.i18n?componentsLang.pc.chinese.footer.reference.icp2:componentsLang.pc.english.footer.reference.icp2}}</a>
          </div>
          <div class="fotBox" :style="$store.state.i18n?'':'letter-spacing:0;'">
            {{$store.state.i18n?componentsLang.pc.chinese.footer.reference.copyRight:componentsLang.pc.english.footer.reference.copyRight}}
            <span v-if="$store.state.i18n"> | <a class="a-link" target="_blank" :href="privacyUrl">{{componentsLang.pc.chinese.footer.reference.privacy}}</a></span>
          </div>
          <div class="fotBox" style="letter-spacing:0;" v-if="!$store.state.i18n"><a class="a-link" target="_blank" :href="privacyUrl">{{componentsLang.pc.english.footer.reference.privacy}}</a></div>
          <div class="fotBox" :style="$store.state.i18n?'':'letter-spacing:0;'">{{$store.state.i18n?componentsLang.pc.chinese.footer.reference.tel:componentsLang.pc.english.footer.reference.tel}}</div>
          <div class="fotBox" :style="$store.state.i18n?'':'letter-spacing:0;'">
            <!-- <img v-show="browser != 'IE'" style="marginRight: 0.417vw;width: 1.25vw;height: 1.458vw" src="@/images/home/1-47.png" /> -->
            <img style="marginRight: 0.417vw;width: 1.25vw;height: 1.458vw" src="@/images/home/1-47.png" />
            <span :style="$store.state.i18n?'':'font-size:1.458vw;letter-spacing: 0vw;'">{{$store.state.i18n?componentsLang.pc.chinese.footer.reference.qq:componentsLang.pc.english.footer.reference.qq}}</span>
          </div>
          <div class="fotBox" :style="$store.state.i18n?'':'letter-spacing:0;'">{{$store.state.i18n?componentsLang.pc.chinese.footer.reference.address:componentsLang.pc.english.footer.reference.address}}</div>
          <div class="fotBox" :style="$store.state.i18n?'':'letter-spacing:0;'">©2017 JDH Information Technology (Guangzhou) Co., Ltd All Rights Reserved</div>
        </div>
      </div>
      <div class="lianjie box">
        <div class="title">
          <div>{{$store.state.i18n?componentsLang.pc.chinese.footer.link.title:componentsLang.pc.english.footer.link.title}}</div>
        </div>
        <div class="main">
            <div class="item" :style="$store.state.i18n?'':'transform: scale(0.5) translateX(-50%);letter-spacing: -0.1vw;'">
              <a target="_blank" href="http://www.pbc.gov.cn/">{{$store.state.i18n?componentsLang.pc.chinese.footer.link.link1:componentsLang.pc.english.footer.link.link1}}</a>
            </div>
            <div class="item" :style="$store.state.i18n?'':'transform: scale(0.5) translateX(-50%);letter-spacing: -0.1vw;'">
              <a target="_blank" href="http://www.shcpe.com.cn/content/shcpe/index.html">{{$store.state.i18n?componentsLang.pc.chinese.footer.link.link2:componentsLang.pc.english.footer.link.link2}}</a>
            </div>
            <div class="item" :style="$store.state.i18n?'':'transform: scale(0.5) translateX(-50%);letter-spacing: -0.1vw;'">
              <a target="_blank" href="https://www.nifa.org.cn/nifa/index.html">{{$store.state.i18n?componentsLang.pc.chinese.footer.link.link3:componentsLang.pc.english.footer.link.link3}}</a>
            </div>
            <div class="item" :style="$store.state.i18n?'':'transform: scale(0.5) translateX(-50%);letter-spacing: -0.1vw;'">
              <a target="_blank" href="https://www.tclmro.com/">{{$store.state.i18n?componentsLang.pc.chinese.footer.link.link4:componentsLang.pc.english.footer.link.link4}}</a>
            </div>
        </div>
      </div>
      <div class="code box">
        <div class="title">
          <div>{{$store.state.i18n?componentsLang.pc.chinese.footer.qrCode.title:componentsLang.pc.english.footer.qrCode.title}}</div>
        </div>
        <div class="main">
            <div class="qrCode">
              <div class="image">
                <img class="bgImage" src="@/images/home/1-25.png"/>
              </div>
              <div class="wenzi" :style="$store.state.i18n?'':'font-size:1vw;letter-spacing: -0.005vw;'">{{$store.state.i18n?componentsLang.pc.chinese.footer.qrCode.qrCode1:componentsLang.pc.english.footer.qrCode.qrCode1}}</div>
            </div>
            
            <div class="qrCode">
              <div class="image">
                <img class="bgImage" src="@/images/home/1-26.png"/>
              </div>
              <div class="wenzi" :style="$store.state.i18n?'':'font-size:1vw;letter-spacing: -0.005vw;'">{{$store.state.i18n?componentsLang.pc.chinese.footer.qrCode.qrCode2:componentsLang.pc.english.footer.qrCode.qrCode2}}</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
    data(){
        return {
          browser:'',
          privacyUrl: ''
        }
    },
    mounted(){
      this.getPrivacyUrl()
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      if (userAgent.indexOf("Trident") > -1) {//判断是否IE浏览器
        this.browser = 'IE';
      }
    },
    methods: {
      getPrivacyUrl () {
        this.privacyUrl = process.env.VUE_APP_OSS_PREFIX + '/newHome/protocol/简单汇信息科技个人信息及隐私保护政策.pdf'
      }
    }
}
</script>




<style scoped>
.bgImage{
  width:100%;height:100%;
}   
.content{
  font-size: 0.729vw;
  letter-spacing: 0.052vw;
  color: #707173;
}
.title{
  font-size: 0.833vw;
  font-weight: bolder;
  letter-spacing: 0.104vw;
  color: #a6a6a6;
  border-bottom: 0.052vw solid #a6a6a6;
  width:100%;
  height:3.385vw;
  margin-bottom: 1.823vw;
}
.footer .content .box .title>div{
  width:auto;height:1.719vw;
  line-height: 1.719vw;
  /* background-color: orange; */
}
.footer .content .box .title1>div{
  width:6.094vw;height:1.719vw;
  line-height: 1.719vw;
}
.footer{
  width:100%;height:20.729vw;
  box-shadow: 0.156vw 0.156vw 0.156vw 0.156vw #000;
  background-color: #282828;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer .content{
  width:65.104vw;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.footer .content .hui{
  width:27.604vw;height:12.5vw;
}
.footer .content .hui .main{
  width:100%;height:7.813vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* background-color: lightcoral; */
}
.footer .content .hui .main .fotBox{
  /* width:100%;height:1.042vw;
  position: relative;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-size: 0.7vw;
  background-color: lightcoral; */

  width:100%;min-height:1.042vw;
  transform: scale(0.5) translateX(-50%);
  font-size: 1.458vw;
  line-height: 1.458vw;
  white-space: nowrap;
}
.a-link {
  color:#707173;
}
.a-link:hover {
  color:#c6151d;
}
.footer .content .hui .main .fotBox1{
  cursor: pointer;
}
.footer .content .hui .main>div:first-child a{
  color:#707173;
}
.footer .content .hui .main>div:first-child:hover a{
  color:#c6151d;
}
.footer .content .code{
  width:20.32%;height:12.5vw;
}
.footer .content .box{
  display: flex;
  flex-direction: column;
  align-items: center;
  height:13.542vw;
}
.footer .content .lianjie{
  width:9.896vw;
}
.footer .content .lianjie .main{
  width: 100%;height: 5.625vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
.footer .content .lianjie .main .item{
  width:100%;height:1.042vw;
  transform: scale(0.5) translateX(-50%);
  font-size: 1.458vw;
  line-height: 1.458vw;
  /* letter-spacing: -0.1vw; */
}
.footer .content .lianjie .main .item a{
  white-space: nowrap;
  color: #707173;
}
.footer .content .lianjie .main .item a:hover{
  color:#c6151d;
}
.footer .content .lianjie .main .item .shuxian{
  width:0.104vw;height:0.521vw;
  background-color:#565759;
}
.footer .content .code .main{
  width:100%;height:7.813vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer .content .code .main .qrCode{
  width:5.573vw;height:7.813vw;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.footer .content .code .main .qrCode .image{
  width:5.573vw;height:5.417vw;
  position: relative;
}
.footer .content .code .main .qrCode .wenzi{
  width:160%;height:2.083vw;
  font-size: 1.3vw;
  transform: scale(0.63);
  /* background-color: orange; */
}
</style>


// WEBPACK FOOTER //
// src/components/footer/footer.vue